import React, { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEmployees } from "@/contexts/EmployeeContext";

interface EmployeeSelectorProps {
  label?: string;
  placeholder?: string;
  className?: string;
  includeTerminatedOption?: boolean;
  onChange?: (employeeId: number | null) => void;
}

const EmployeeSelector: React.FC<EmployeeSelectorProps> = ({
  label = "Employee",
  placeholder = "All employees",
  className,
  includeTerminatedOption = false,
  onChange,
}) => {
  const { employees, selectedEmployeeId, setSelectedEmployeeId } = useEmployees();

  const options = useMemo(() => {
    return employees.map((e) => ({
      id: e.id,
      name: `${e.firstName} ${e.lastName}`.trim(),
      isActive: (e as any).isActive !== false,
    }));
  }, [employees]);

  const value = selectedEmployeeId?.toString() ?? "all";

  const handleChange = (val: string) => {
    const newValue = val === "all" ? null : Number(val);
    setSelectedEmployeeId(newValue);
    onChange?.(newValue);
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      )}
      <Select value={value} onValueChange={handleChange}>
        <SelectTrigger className="w-64">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{placeholder}</SelectItem>
          {options.map((opt) => (
            <SelectItem key={opt.id} value={opt.id.toString()}>
              {opt.name}
              {!opt.isActive && includeTerminatedOption ? " (terminated)" : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default EmployeeSelector;




